import React from 'react';
import { Chip } from '@mui/material';
import { stageColors } from '../../theme';
import { getStageDisplayName } from '../../utils/helpers';

const StageChip = ({ stage, size = 'small', onClick, ...props }) => {
  const color = stageColors[stage] || '#6b7280';

  return (
    <Chip
      label={getStageDisplayName(stage)}
      size={size}
      onClick={onClick}
      sx={{
        bgcolor: `${color}20`,
        color: color,
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        border: `1px solid ${color}40`,
        '& .MuiChip-label': { px: 1 },
        '&:hover': onClick ? {
          bgcolor: `${color}30`,
        } : {},
        cursor: onClick ? 'pointer' : 'default',
      }}
      {...props}
    />
  );
};

export default StageChip;
